import { render, staticRenderFns } from "./QuizAnswer.vue?vue&type=template&id=38e2ba10&scoped=true&"
import script from "./QuizAnswer.vue?vue&type=script&lang=ts&"
export * from "./QuizAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./QuizAnswer.vue?vue&type=style&index=0&id=38e2ba10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2ba10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
